import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_ROOT = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';
const PLATFORM_V1 = `${API_ROOT}/v1`;

/** v2 : aligné sur GET /agora/initiatives/resolve-for-entrea (initiative avec rapports si pas de project_id) */
const CACHE_ID = 'agora_initiative_id_v2';
const CACHE_PROJECT = 'agora_initiative_project_id_v2';

/**
 * Résout l'initiative Agora pour les rapports (procès-verbaux Entrea).
 * Priorité : REACT_APP_AGORA_INITIATIVE_ID → cache (même projet) → API resolve-for-entrea.
 */
export async function resolveAgoraInitiativeId() {
  const envId = (process.env.REACT_APP_AGORA_INITIATIVE_ID || '').trim();
  if (envId) return envId;

  const projectId = localStorage.getItem('project_id');
  const cachedId = localStorage.getItem(CACHE_ID);
  const cachedProj = localStorage.getItem(CACHE_PROJECT);
  if (cachedId && cachedProj === (projectId || '')) {
    return cachedId;
  }

  const res = await axios.get(`${PLATFORM_V1}/agora/initiatives/resolve-for-entrea`, {
    params: projectId ? { project_id: projectId } : {},
  });
  const id = res.data?.id;
  if (!id) {
    throw new Error('Résolution initiative Agora : réponse invalide.');
  }

  localStorage.setItem(CACHE_ID, id);
  localStorage.setItem(CACHE_PROJECT, projectId || '');
  return id;
}

export function clearAgoraInitiativeCache() {
  localStorage.removeItem(CACHE_ID);
  localStorage.removeItem(CACHE_PROJECT);
  // Ancienne clé de cache (avant resolve-for-entrea)
  localStorage.removeItem('agora_initiative_id');
  localStorage.removeItem('agora_initiative_project_id');
}
